import type { PortfolioImage } from './portfolioSections';
import { t } from '@utils/translate';
import { renderTranslation } from '@utils/renderTranslation';

/**
 * Main heading for a portfolio item detail page when `uxCaseStudy` is present:
 * `{sectionTitle} {joiner} {image.title}` (e.g. "Web development notes for Numinica").
 */
export function portfolioUxCaseStudyHeroTitle(image: PortfolioImage, locale: 'en' | 'es'): string {
  const ux = image.uxCaseStudy;
  const imageTitle = (image.title ?? '').trim();
  const sectionTitlePart = ux?.sectionTitle?.trim();
  if (!ux || !sectionTitlePart) {
    return imageTitle;
  }
  const joiner = String(
    renderTranslation(t('ux_case_study_title_joiner', 'portfolio', locale)) ||
      (locale === 'es' ? 'para' : 'for')
  );
  return `${sectionTitlePart} ${joiner} ${imageTitle}`.trim();
}
